import { useState, useEffect } from "react";
import * as yup from "yup";

export const useValidName = (initialValue: string | null) => {
  const [name, setName] = useState(initialValue);
  const [nameIsValid, setNameIsValid] = useState("");

  useEffect(() => {
    const nameSchema = yup.object().shape({
      name: yup.string().min(1).required(),
    });

    if (name !== null) {
      if (name.length === 0 || name.length > 50) {
        setNameIsValid("Please enter a name between 1 and 50 characters.");
        return;
      }
    } else {
      setNameIsValid("");
      return;
    }

    const isValid = nameSchema.isValidSync({ name });
    if (!isValid) {
      setNameIsValid("The name is required. Please complete the Name field");
      return;
    }

    setNameIsValid("");
  }, [name]);

  return { name, setName, nameIsValid };
};
